export default __webpack_public_path__ + "static/media/lifeSituation.4c14e065.svg";